var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view_comfy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-171.000000, -2729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(100.000000, 2626.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Image-/-view_comfy",
    transform: "translate(68.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,9 L7,9 L7,5 L5,5 C3.9,5 3,5.9 3,7 L3,9 Z M3,14 L7,14 L7,10 L3,10 L3,14 Z M8,14 L12,14 L12,10 L8,10 L8,14 Z M13,14 L17,14 L17,10 L13,10 L13,14 Z M8,9 L12,9 L12,5 L8,5 L8,9 Z M13,5 L13,9 L17,9 L17,5 L13,5 Z M18,14 L22,14 L22,10 L18,10 L18,14 Z M5,19 L7,19 L7,15 L3,15 L3,17 C3,18.1 3.9,19 5,19 Z M8,19 L12,19 L12,15 L8,15 L8,19 Z M13,19 L17,19 L17,15 L13,15 L13,19 Z M18,19 L20,19 C21.1,19 22,18.1 22,17 L22,15 L18,15 L18,19 Z M18,5 L18,9 L22,9 L22,7 C22,5.9 21.1,5 20,5 L18,5 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#ffffff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/gridView.bc6b671263b37c3a5e6cfd361587ea6f.svg";
export { ForwardRef as ReactComponent };